import { lodash } from 'helpers';
import { useFormContext } from 'libs/form/useFormContext';
import { useTranslation } from 'libs/i18n';

import { useOrderContext } from '../../../providers/OrderProvider';
import { OrderSection } from '../../OrderSection';

export const MainInformationSection = () => {
  const { t } = useTranslation();
  const { order } = useOrderContext();

  const { readOnly } = useFormContext();

  if (!order) {
    return null;
  }

  return (
    <OrderSection
      fields={lodash.compact([
        {
          label: t(
            'account.order.sections.mainInformationSection.fields.operationType.label'
          ),
          value: t(`account.order.types.${order.operationType}`),
          disabled: !readOnly,
        },
        {
          label: t(
            'account.order.sections.mainInformationSection.fields.number.label'
          ),
          value: order.number,
          disabled: !readOnly,
        },
      ])}
      title={t('account.order.sections.mainInformationSection.title')}
    />
  );
};
